import { anyOf, objectOf } from "@altostra/type-validations";
import { boolean, nullOrUndefined, number } from "@altostra/type-validations/lib/primitives";

export const isGetEngagementAppGroupIdDestinationCanvasNotificationDismissedWorkflowIdResult = objectOf({
  dismissed_at: anyOf(number, nullOrUndefined),
});

export const isPostEngagementAppGroupIdDestinationCanvasNotificationDismissedWorkflowIdResult = objectOf({
  success: boolean,
});
